import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { Merchant } from "../../supplier/reporting/merchants/merchantTypes"
import React from "react"
import { MerchantTableRow } from "./MerchantTableRow"

const useStyles = makeStyles()((_theme) => ({
    page: {
        paddingTop: "3rem",
    },
    merchantList: {
        marginTop: "2rem",
    },
    skeleton: {
        maxWidth: "15rem",
    },
    xs: {
        width: "2rem",
        padding: 0,
        textAlign: "center",
        verticalAlign: "middle",
    },
    s: {
        width: "5rem",
    },
    m: {
        width: "12rem",
    },
}))

function TableCellSkeleton() {
    const { classes } = useStyles()

    return <Skeleton variant="rectangular" animation="wave" className={classes.skeleton} />
}

type Props = Readonly<{
    merchants?: Merchant[] | undefined
    onMerchantClick?: (merchant: Merchant) => void
    showDetailsRow?: boolean
}>

export function MerchantsTable({ merchants, onMerchantClick, showDetailsRow = false }: Props) {
    const { classes } = useStyles()

    return (
        <TableContainer component={Paper} className={classes.merchantList}>
            <Table>
                <TableHead>
                    <TableRow>
                        {showDetailsRow && <TableCell className={classes.xs}></TableCell>}
                        <TableCell className={classes.s}>
                            <LocalizedStrict id="supplier-merchant-access-table-header-case-no">
                                <span>Case No.</span>
                            </LocalizedStrict>
                        </TableCell>
                        <TableCell className={classes.m}>
                            <LocalizedStrict id="supplier-merchant-access-table-header-name">
                                <span>Name</span>
                            </LocalizedStrict>
                        </TableCell>
                        <TableCell className={classes.m}>
                            <LocalizedStrict id="supplier-merchant-access-table-header-address">
                                <span>Address</span>
                            </LocalizedStrict>
                        </TableCell>
                        <TableCell className={classes.xs}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!Boolean(merchants) && (
                        <TableRow>
                            <TableCell className={classes.s}>
                                <TableCellSkeleton />
                            </TableCell>
                            <TableCell className={classes.m}>
                                <TableCellSkeleton />
                            </TableCell>
                            <TableCell className={classes.m}>
                                <TableCellSkeleton />
                            </TableCell>
                        </TableRow>
                    )}
                    {merchants?.map((merchant) => (
                        <MerchantTableRow
                            key={merchant.id}
                            showDetailsRow={showDetailsRow}
                            merchant={merchant}
                            onMerchantClick={onMerchantClick}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
